<template>
  <div class="source-contrast">
    <div class="title">
      <div>{{ sourceComInfo.title }}</div>
      <p>
        <em>{{ sourceComInfo.contrastNum }}</em
        >&nbsp;&nbsp;<span
          >大横向对比,&nbsp;&nbsp;专注课程本身,&nbsp;&nbsp;面向大数据未来,&nbsp;&nbsp;谁与争锋</span
        >
      </p>
    </div>
    <div class="new-content">
      <!-- 左边 -->
      <div class="list-left">
        <!-- 表头部分 -->
        <div>
          <p style="font-size: 24px;">{{ sourceComInfo.projectTitle }}</p>
        </div>
        <ul style="border-radius: 16px;">
          <li v-for="(item, index) in sourceComInfo.project" :key="index">
            {{ item }}
          </li>
        </ul>
      </div>
      <!-- 中间 -->
      <div class="list-center">
        <div>
          <p style="font-size: 24px;">传智教育</p>
        </div>
        <ul style="border-radius: 16px;">
          <li><span class="center-span">83天(其中授课时长 52天)</span></li>
          <li>
            <span style="display:inline-block;margin-top: 30px;"
              >包含数据采集、数据清洗、数据预处理、离线批处理、实时计<br />算、BI、调度、资源管理等全套解决方案</span
            >
          </li>
          <li><span class="center-span">来自于真实项目场景业务数据</span></li>
          <li>
            <span class="center-span"
              >针对HBase、Hive、Flink、Spark、Kudu、Impala的性能优化</span
            >
          </li>
          <li class="video-li">
            <span class="viedo-p">
              采用150台8核32GAWS服务器进行1200亿单表单日<br />数据处理以验证架构调优方案<br />
              <span
                class="img-word"
                @click="getVideoDialog()"
                v-track="['点击播放', '点击播放']"
              >
                <img class="img-h" src="../bigDataImg/btn_play.png" alt="" />
                <span class="video-span">查看调优过程</span>
              </span>
            </span>
          </li>
          <li>
            <span style="display:inline-block;margin-top: 30px;"
              >通过星途车联网以及今日指数项目的学习，掌握真实企业中实时<br />处理的完整架构，帮助企业从LAMBDA过渡到KAPPA架构</span
            >
          </li>
          <li>
            <span
              style="display:inline-block;margin-top: 30px;border-radius: 16px;"
              >Flink流批一体全栈课程，助力企业统一编程接口、统一资源管<br />理、统一架构体系，提高代码复用率，提高企业开发效率</span
            >
          </li>
        </ul>
      </div>
      <!-- 右边 -->
      <div class="list-right">
        <div class="right-msg">
          <p>
            {{ sourceComInfo.trainTitle }}<br /><span>{{
              sourceComInfo.trainWord
            }}</span>
          </p>
        </div>
        <ul>
          <li v-for="(item, index) in sourceComInfo.otherTrain" :key="index">
            {{ item }}
          </li>
        </ul>
      </div>
    </div>
    <MenuAdd ref="editMenu" />
  </div>
</template>

<script>
import MenuAdd from "@/views/components/video";

export default {
  props: {
    sourceComInfo: {
      readonly: true,
      require: true,
      default: () => {},
    },
  },
  components: {
    MenuAdd,
  },
  data() {
    return {};
  },
  methods: {
    getVideoDialog() {
      this.$refs.editMenu.dialogFormV({
        url: "https://v.itheima.net/bigdata/hE7P@WM2.mp4",
      });
      // this.$trackEvent("查看调优过程", '点击播放', "查看调优过程")
    },
  },
};
</script>

<style lang="scss" scoped>
.source-contrast {
  background-color: #fff;
  width: 100%;
  .new-content {
    max-width: 1200px;
    margin: 40px auto 100px auto;
    height: 758px;
    width: 1200px;
    zoom: 1;
    display: flex;
    color: #19232B;
    // 左边
    .list-left {
      width: 170px;
      height: 758px;
      box-shadow: 0px 4px 2px 0px rgba(0, 0, 0, 0.1);
      border-radius: 16px;
      z-index: 10;
      div {
        width: 100%;
        height: 100px;
        background-color: #ff743c;
        border-top-left-radius: 16px;
        border-top-right-radius: 16px;
        p {
          text-align: center;
          line-height: 100px;
          color: #fff;
          font-size: 24px;
          font-family: "MicrosoftYaHei", "PingFangSC", "PingFangSC-Semibold";
        }
      }
      ul {
        width: 100%;
        li {
          text-align: center;
          width: 100%;
          height: 94px;
          line-height: 94px;
        }
        li:nth-child(even) {
          background-color: #fff9f7;
        }
      }
    }
    // 中间
    .list-center {
      width: 580px;
      height: 758px;
      box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
      border-radius: 16px;
      z-index: 10;
      div {
        width: 100%;
        height: 100px;
        background-image: linear-gradient(to right, #25bbff, #1086ff);
        border-top-left-radius: 16px;
        border-top-right-radius: 16px;
        p {
          text-align: center;
          color: #fff;
          font-size: 24px;
          line-height: 100px;
          font-family: "MicrosoftYaHei", "PingFangSC", "PingFangSC-Semibold";
        }
      }
      ul {
        width: 100%;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
        li {
          text-align: center;
          width: 100%;
          height: 94px;
          .center-span {
            display: inline-block;
            margin-top: 40px;
          }
          .viedo-p {
            display: inline-block;
            margin-top: 30px;
            .img-word {
              cursor: pointer;
              margin-top: 4px;
              display: inline-block;
              img {
                width: 20px;
                vertical-align: middle;
              }
              .video-span {
                color: #1086ff;
                margin-left: 6px;
              }
            }
            .img-word:hover,
            .video-span:hover {
              color: #63afff;
            }
          }
        }
        li:nth-child(even) {
          background-color: #f1f8ff;
        }
        li:last-child {
          border-radius: 16px;
        }
      }
    }
    // 右边
    .list-right {
      width: 450px;
      height: 758px;
      border-top: 1px solid #ccc;
      border-right: 1px solid #ccc;
      border-bottom: 1px solid #ccc;
      border-radius: 16px;
      .right-msg {
        width: 100%;
        height: 100px;
        background-color: #d6d6d6;
        border-top-left-radius: 16px;
        border-top-right-radius: 16px;
        p {
          font-family: "MicrosoftYaHei", "PingFangSC", "PingFangSC-Semibold";
          padding-top: 6%;
          text-align: center;
          font-size: 24px;
          box-sizing: border-box;
          span {
            font-size: 14px;
          }
        }
      }
      ul {
        width: 100%;
        li {
          text-align: center;
          width: 100%;
          height: 94px;
          line-height: 94px;
        }
        li:nth-child(even) {
          background-color: #f7f7f7;
        }
      }
    }
  }
}
.source-contrast {
  max-width: 1200px;
  width: 100%;
  height: auto;
  margin: 76px auto;
  // overflow: hidden;
  min-width: 1200px;
  .title {
    font-size: 32px;
    font-family: PingFangSC;
    font-weight: 600;
    text-align: center;
    color: #19232b;
    line-height: 45px;
    z-index: 2;
    div {
      font-size: 32px;
      font-weight: 400;
      color: #19232B;
      // font-family: "Fontquan-qingkehuangyouti";
      font-family: "MicrosoftYaHei", "PingFangSC", "PingFangSC-Regular";
    }
    p {
      font-size: 16px;
      font-family: PingFangSC;
      text-align: center;
      line-height: 70px;
      font-weight: 400;
      z-index: 2;
      margin-bottom: 14px;
      color: #616a72;
      em {
        display: inline-block;
        width: 21px;
        height: 21px;
        border-radius: 4px;
        background-color: #ff743c;
        line-height: 21px;
        color: #fff;
      }
      span {
        display: inline-block;
        height: 28px;
        line-height: 28px;
      }
    }
  }
}
</style>
